<template>
  <div class="step" :class="{ active: user }">
    <BaseIcon glyph="logo" width="32px" class="mb-s" />
    <p class="mb-xs fw-700">Шаг 1</p>
    <p class="step-description">
      Быть зарегистрированным участником
      <a
        :href="talentLink"
        target="_blank"
        rel="noopener noreferrer"
        title="Платформа Талант"
        class="link-text"
        >платформы &laquo;Талант&raquo;</a
      >.
    </p>
    <div v-if="user" class="info-block">
      <StepInfo class="mt-s" />
      <StepInfo class="mt-s" info-text="Вы зарегистрированы" />
      <BaseButton
        tag="a"
        :href="talentLink"
        target="_blank"
        rel="noopener noreferrer"
        class="mt-s"
        size="xs"
        shape="square"
        >Перейти в профиль</BaseButton
      >
    </div>
  </div>
</template>

<script>
import StepInfo from "@/components/StepInfo";
export default {
  name: "RegistrationStep",
  components: {
    StepInfo,
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    talentLink() {
      return process.env.VUE_APP_TALENT_HOST;
    },
  },
};
</script>

<style lang="less" scoped>
.step {
  padding: 20px;
  width: 100%;
  border-radius: @border-radius-xs;
  border: 1px solid @blue-color;
  background-color: #fff;
  color: @primary-color;
  display: flex;
  flex-direction: column;

  &-description {
    color: @base-color;
  }

  &.active {
    background-color: @background-blue;
    border-color: @info-color;
    color: @base-color;
  }
}

.info-block {
  margin-top: auto;
}

@media (max-width: @screen-xs-max) {
  .step {
    max-width: 100%;
  }
}
</style>
